import { render, staticRenderFns } from "./FeGino.vue?vue&type=template&id=45747d5e&"
import script from "./FeGino.vue?vue&type=script&lang=js&"
export * from "./FeGino.vue?vue&type=script&lang=js&"
import style0 from "./FeGino.vue?vue&type=style&index=0&id=45747d5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports